export enum HeaderVariantEnum {
  Attendee = 'attendee',
  Organizer = 'organizer',
}
